import { BaseApi } from './base.api.js';

export class ThreatApi extends BaseApi {
    constructor(client) {
        super(client, '/threat');
    }
}
